<!-- <h2>Work Safety Events</h2> -->



<!-- <table mat-table [dataSource]="events" class="mat-elevation-z8">
  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef>Date</th>
    <td mat-cell *matCellDef="let event">{{ event.date }}</td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef>Type</th>
    <td mat-cell *matCellDef="let event">{{ event.type }}</td>
  </ng-container>

  <ng-container matColumnDef="severity">
    <th mat-header-cell *matHeaderCellDef>Severity</th>
    <td mat-cell *matCellDef="let event">{{ event.severity }}</td>
  </ng-container>

  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Description</th>
    <td mat-cell *matCellDef="let event">{{ event.description }}</td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['date', 'type', 'severity', 'description']"></tr>
  <tr mat-row *matRowDef="let row; columns: ['date', 'type', 'severity', 'description'];"></tr>
</table> -->
<router-outlet></router-outlet>
